import { PageItemAddressDetails, PageItemAddressDetailsEnum } from '../../TransfersTypes'
import { useMemo } from 'react'
import TableMui from 'src/components/TableMui'

interface Props {
  type: string
  pageItemAddressesDetails: PageItemAddressDetails[]
}

export const TableItemAddressesDetails = ({ type, pageItemAddressesDetails }: Props) => {
  const inputQuantityLabel = () => {
    switch (type) {
      case PageItemAddressDetailsEnum.COLLECT:
        return 'Qtd. da planilha'
      case PageItemAddressDetailsEnum.RESTOCK:
        return 'Qtd. à repor'
      default:
        return ''
    }
  }

  const doneQuantityLabel = () => {
    switch (type) {
      case PageItemAddressDetailsEnum.COLLECT:
        return 'Qtd. coletada'
      case PageItemAddressDetailsEnum.RESTOCK:
        return 'Qtd. reposta'
      default:
        return ''
    }
  }

  const resolveTableRows = useMemo(() =>
    pageItemAddressesDetails.map(({
      address,
      inputQuantity,
      doneQuantity,
      dueDate,
      userStarted,
      startedAt,
      userFinished,
      finishedAt,
      status,
      observation,
    }) => ({
      address,
      inputQuantity,
      doneQuantity: doneQuantity === null ? '-' : String(doneQuantity),
      dueDate,
      userStarted,
      startedAt,
      userFinished,
      finishedAt,
      status,
      observation,
    })), [pageItemAddressesDetails])

  return (
    <TableMui
      columns={[
        { id: 'address', label: 'Endereço' },
        { id: 'inputQuantity', label: inputQuantityLabel() },
        { id: 'doneQuantity', label: doneQuantityLabel() },
        { id: 'dueDate', label: 'Data de validade' },
        { id: 'userStarted', label: 'Iniciado por' },
        { id: 'startedAt', label: 'Iniciado em' },
        { id: 'userFinished', label: 'Finalizado por' },
        { id: 'finishedAt', label: 'Finalizado em' },
        { id: 'status', label: 'Status' },
        { id: 'observation', label: 'Observação' },
      ]}
      emptyLabel='Nenhum endereço para exibir'
      rows={resolveTableRows}
      rowCount={resolveTableRows.length}
      enablePagination
      rowsPerPageLimit={10}
      maxHeight='60vh'
      testId='table-page-item-addresses-details-test'
    />
  )
}
